/**
 * Chat attachment download utilities and validation
 */

import { apiFetch } from "./apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

// Allowed MIME types (must match backend .env)
const ALLOWED_MIME_TYPES = {
    'image/jpeg': ['jpg', 'jpeg'],
    'image/png': ['png'],
    'image/gif': ['gif'],
    'image/webp': ['webp'],
    'application/pdf': ['pdf']
};

/**
 * Validate file type before upload
 * @param {File} file - File to validate
 * @returns {object} - { isValid: boolean, error: string }
 */
export const validateFileType = (file) => {
    if (!file) {
        return { isValid: false, error: "Файл не вибраний" };
    }

    const mimeType = file.type;
    const extension = file.name.split('.').pop().toLowerCase();

    // Check MIME type
    if (!ALLOWED_MIME_TYPES[mimeType]) {
        const allowedExts = Object.values(ALLOWED_MIME_TYPES).flat().join(', ');
        return {
            isValid: false,
            error: `Недопустимий тип файлу. Дозволені: ${allowedExts}`
        };
    }

    // Check extension matches MIME type
    if (!ALLOWED_MIME_TYPES[mimeType].includes(extension)) {
        return {
            isValid: false,
            error: "Розширення файлу не збігається з типом"
        };
    }

    return { isValid: true, error: null };
};

export const downloadAttachment = async (filename) => {
    try {
        const res = await apiFetch(`${API_BASE}/chat/client/download/${filename}`);
        if (!res.ok) throw new Error("Не вдалося скачати файл");

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true;
    } catch (error) {
        console.error("Download error:", error);
        throw error;
    }
};

export const getAttachmentInfo = async () => {
    const res = await apiFetch(`${API_BASE}/chat/attachments/info`);
    if (!res.ok) throw new Error("Не вдалося завантажити інформацію про прикріплення");
    return await res.json();
};
